import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function Text({
    children,
    size = 'md',
    color = 'black',
    fontWeight = 'normal',
    fontStyle = 'normal',
    tag = 'p',
    className,
    hasMarginBetween = false,
    isTruncated = false,
    ...rest
}) {
    const Tag = tag;

    return (
        <Tag
            className={cx('sarsa-text', className, {
                'color-gray': color === 'gray',
                'color-white': color === 'white',
                'size-xl': size === 'xl',
                'size-lg': size === 'lg',
                'size-sm': size === 'sm',
                'size-xs': size === 'xs',
                'weight-bold': fontWeight === 'bold',
                'weight-semibold': fontWeight === 'semibold',
                'style-italic': fontStyle === 'italic',
                'margin-between': hasMarginBetween,
                'truncated': isTruncated
            })}
            {...rest} >
            {children}
        </Tag>
    );
}

Text.propTypes = {
    children: PropTypes.node,
    size: PropTypes.oneOf(['xl', 'lg', 'md', 'sm', 'xs']),
    color: PropTypes.oneOf(['black', 'gray', 'white']),
    tag: PropTypes.string,
    fontWeight: PropTypes.oneOf(['normal', 'semibold', 'bold']),
    fontStyle: PropTypes.oneOf(['normal', 'italic']),
    hasMarginBetween: PropTypes.bool,
    isTruncated: PropTypes.bool,
    className: PropTypes.string
}
